import { render, staticRenderFns } from "./comEdit.vue?vue&type=template&id=d63f4e34&scoped=true"
import script from "./comEdit.vue?vue&type=script&lang=js"
export * from "./comEdit.vue?vue&type=script&lang=js"
import style0 from "./comEdit.vue?vue&type=style&index=0&id=d63f4e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63f4e34",
  null
  
)

export default component.exports